import { useState } from "react";
import type { SortDirection } from "../ui/DataTable/types";

export const useSortHandler = (initialColumn: string, initialDirection: SortDirection) => {
  const [sortColumn, setSortColumn] = useState<string>(initialColumn);
  const [sortDirection, setSortDirection] = useState<SortDirection>(initialDirection);

  const handleSort = (columnKey: string) => {
    if (columnKey === sortColumn) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      const isNameColumn = columnKey === "name";
      setSortColumn(columnKey);
      setSortDirection(isNameColumn ? "asc" : "desc");
    }
  };

  return { sortColumn, sortDirection, handleSort };
};
